'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (classNameBuilder) {
    return function (addBemClassName, Tag) {
        var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var block = arguments[3];
        var elem = arguments[4];
        var mods = arguments[5];
        var mixes = arguments[6];
        var cls = arguments[7];
        var content = arguments[8];

        var className = addBemClassName ? classNameBuilder.stringify(block, elem, mods, classNameBuilder.joinMixes(mixes), cls) : undefined;

        var tagProps = _extends({ className: className }, attrs);
        return _react2.default.createElement(
            Tag,
            tagProps,
            content
        );
    };
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }